module.exports = __webpack_public_path__ + "a0c835eed2fe62e083bbe3bfeee03a79.png";